<template>
    <div class="info" v-if="isShow">
        <div class="title">
            <span>{{ title }}</span>
        </div>
        <div :style="`margin: auto; text-align: center`">
            {{ 0 }}
            <span
                class="tif-color-pan"
                v-for="(item, index) in legend"
                :key="index"
                :style="`background:${item.color};font-size: 12px;`"
            >
                {{ item.name }}
            </span>
            <span class="ml-2">{{ legend[legend.length - 1].value }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Legend'
        },
        legend: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isShow: false
        };
    },
    mounted() {
        for (const item of this.legend) {
            if (item.value) {
                this.isShow = true;
                break;
            }
        }
    }
};
</script>
<style lang="scss">
.info {
    padding: 6px 8px;

    .title {
        font-weight: 600;
        margin-bottom: 5px;
        text-align: center;

        span {
            background: #292562;
            color: #fff;
            border-radius: 5px;
            padding-left: 4px;
            padding-right: 4px;
        }
    }
    .tif-color-pan {
        width: 30px;
        padding: 2px 30px;
        color: #fff;
    }
}
</style>
